import {useEffect, useRef} from "react";
import * as h3 from "h3-js";

if (typeof window !== "undefined" && !window.openInfoWindows) {
    window.openInfoWindows = [];
}

export const Hexagon = ({
    hexagon,
    hoverHexagon,
    color,
    opacity,
    isSelected,
    isPreview,
    maps,
    setHoverHexagon,
    map,
    zIndex,
    showTooltip = false,
    tooltip = null
}) => {
    const polygonRef = useRef(null);
    const timeoutsRef = useRef({
        show: null,
        hide: null
    });

    function createTooltipContent(tooltip) {
        if (!tooltip) return "";
        return `
            <style>${globalStyles}</style>
            <div class="custom-tooltip">
                <div style="display: flex; justify-content: space-between; align-items: center; background: #f5f7fa; color: #222; font-size: 16px; font-weight: 700; padding: 14px 18px 8px 18px; border-bottom: 1px solid #ececec; letter-spacing: 0.01em;">
                    <span>${tooltip.title || ""}</span>
                    <span class="tooltip-close" style="cursor:pointer; font-size:20px; padding-left:12px;" id="custom-tooltip-close">×</span>
                </div>
                ${tooltip.content || ""}
            </div>
        `;
    }

    function clearAllTimeouts() {
        Object.values(timeoutsRef.current).forEach(timeout => {
            if (timeout) clearTimeout(timeout);
        });
        timeoutsRef.current = {show: null, hide: null};
    }

    useEffect(() => {
        if (showTooltip && !tooltip) {
            return;
        }

        if (!maps || !map || !hexagon) {
            return;
        }

        const vertices = h3.cellToBoundary(hexagon);
        const paths = vertices.map(([lat, lng]) => new maps.LatLng(lat, lng));
        const isHovered = hoverHexagon === hexagon;

        const polygon = new maps.Polygon({
            paths,
            map,
            fillColor: color || "#FF0000",
            fillOpacity: isPreview ? 0.15 : isHovered ? 0.5 : opacity || 0.3,
            strokeColor: isPreview ? "#FFFF00" : color || "#FF0000",
            strokeWeight: 0.3,
            strokeOpacity: isPreview ? 0.5 : 0.8,
            clickable: tooltip ? true : false,
            geodesic: true,
            zIndex: zIndex || 1000
        });
        polygonRef.current = polygon;

        const clickListener = maps.event.addListener(polygon, "click", event => {
            if (!tooltip) {
                return;
            }

            clearAllTimeouts();

            if (window.openInfoWindows && Array.isArray(window.openInfoWindows)) {
                window.openInfoWindows.forEach(iw => iw.close());
                window.openInfoWindows = [];
            }

            const infoWindow = new maps.InfoWindow({
                content: createTooltipContent(tooltip),
                disableAutoPan: false,
                pixelOffset: new maps.Size(0, -10),
                zIndex: (zIndex || 1000) + 1000
            });
            infoWindow.setPosition(event.latLng);
            infoWindow.open(map);

            maps.event.addListener(infoWindow, "domready", () => {
                const closeBtn = document.getElementById("custom-tooltip-close");
                if (closeBtn) {
                    closeBtn.onclick = () => {
                        infoWindow.close();
                        window.openInfoWindows = window.openInfoWindows.filter(
                            iw => iw !== infoWindow
                        );
                    };
                }
            });
            window.openInfoWindows.push(infoWindow);
        });

        const mouseoverListener = maps.event.addListener(polygon, "mouseover", event => {
            if (!tooltip) {
                return;
            }
            setHoverHexagon(hexagon);
        });

        const mouseoutListener = maps.event.addListener(polygon, "mouseout", () => {
            if (!tooltip) {
                return;
            }
            setHoverHexagon(null);
        });

        const zoomListener = maps.event.addListener(map, "zoom_changed", () => {
            if (!tooltip) {
                return;
            }
            clearAllTimeouts();
            setHoverHexagon(null);
        });

        const dragListener = maps.event.addListener(map, "dragstart", () => {
            if (!tooltip) {
                return;
            }
            clearAllTimeouts();
            setHoverHexagon(null);
        });

        return () => {
            clearAllTimeouts();

            [
                clickListener,
                zoomListener,
                dragListener,
                mouseoverListener,
                mouseoutListener
            ].forEach(listener => {
                if (listener) maps.event.removeListener(listener);
            });

            if (polygon) {
                polygon.setMap(null);
            }
        };
    }, [
        hexagon,
        color,
        opacity,
        isSelected,
        isPreview,
        maps,
        map,
        zIndex,
        showTooltip,
        tooltip,
        hoverHexagon,
        JSON.stringify(tooltip)
    ]);

    return null;
};

const globalStyles = `
    .custom-tooltip {
        background: #fff;
        border-radius: 14px;
        box-shadow: 0 8px 32px rgba(60,60,60,0.18);
        max-width: 320px;
        min-width: 200px;
        padding: 0;
        overflow: hidden;
    }
    .tooltip-title {
        background: #f5f7fa;
        color: #222;
        font-size: 16px;
        font-weight: 700;
        padding: 14px 18px 8px 18px;
        border-bottom: 1px solid #ececec;
        letter-spacing: 0.01em;
    }
    .tooltip-content {
        font-size: 14px;
        color: #444;
        padding: 10px 18px 18px 18px;
        line-height: 1.6;
        background: #fff;
    }
  

    .gm-style-iw-c {
        background: transparent !important;
        padding: 0 !important;
        margin: 0 !important;
        border: none !important;
        box-shadow: none !important;
        border-radius: 0 !important;
        overflow: hidden !important;
        width: unset !important;
        height: unset !important;
        max-width: unset !important;
        min-width: unset !important;
        max-height: unset !important;
        min-height: unset !important;
    }

     .gm-style-iw-d {
        background: transparent !important;
        padding: 0 !important;
        margin: 0 !important;
        border: none !important;
        box-shadow: none !important;
        border-radius: 0 !important;
        overflow: hidden !important;
        width: unset !important;
        height: unset !important;
        max-width: unset !important;
        min-width: unset !important;
        max-height: unset !important;
        min-height: unset !important;
    }

      .gm-style-iw-chr {
        display: none !important;
    }
`;
